<template>
  <div class="create-route">
    <div class="search-box">
      <Search
        v-model.trim="routeParams.searchText"
        :clearable="false"
        show-action
        placeholder="搜索"
        @search="onSearch"
        @cancel="onCancel"
        background="#fff"
        ref="searchArea"
      >
        <template #left-icon class="23343">
          <img @click="onSearch" src="../../assets/images/icon_search.png" />
        </template>
      </Search>
    </div>
    <div class="list-box">
      <div class="list-box-content" id="listBoxContent">
        <CheckboxGroup v-model.trim="selLineList" :max="6" checked-color="#f44514" v-if="routeList.length" @change="handleChangeCheckBox">
          <ListItem :item="item" v-for="item in routeList" :key="item.id" :selCheckBoxlength="selLineList.length" :handleCheckBoxClicked="handleCheckBoxClicked"></ListItem>
        </CheckboxGroup>
      </div>
      <NoWorksData v-if="showNoData && !routeList.length" noDataText="暂无数据" />
    </div>
    <div :class="['bottom-btn', isHeightLinght && 'active']" @click="handleCreateRoute">
      <div>定制路线（已选{{ selLineList.length }}个红色遗址）</div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { Search, Checkbox, CheckboxGroup } from 'vant'
import ListItem from './components/ListItem'
import NoWorksData from '@/components/NoWorksData'
import { getRedRouteByCity, createRedRoute } from '@/server/interfaces'
import { getDistance } from '@/utils/amap'
import { buryingPoint } from '@/utils/buryingPoint'
const body = document.body.getBoundingClientRect()

export default {
  name: '',
  components: { Search, Checkbox, CheckboxGroup, ListItem, NoWorksData },
  data() {
    return {
      routeList: [],
      /**是否在请求列表数据 */
      isLoading: false,
      showNoData: false,
      /**是否最后一页 */
      isLastPage: false,
      /**总页数 */
      totalPages: 1,
      /**已选择的路线 */
      selLineList: [],
      /**路线请求部分参数 */
      routeParams: {
        pageNum: 0,
        pageSize: 10,
        categoryIds: [],
        searchText: '',
      },
      userPosition: null,
      defaultPosition: {
        latitude: 23.137,
        longitude: 113.325,
        valid: true,
      },
    }
  },
  computed: {
    ...mapGetters({
      selectedCity: 'home/selectedCity',
      activityId: 'activityInfo/activityId',
    }),
    isHeightLinght() {
      return this.selLineList.length >= 2
    },
  },
  async mounted() {
    buryingPoint({ action: 1, sourceTag: 3, activityId: this.activityId, itemType: 2 })
    this.$refs.searchArea.querySelector('input').addEventListener('click', ()=> {
      buryingPoint({ action: 17, sourceTag: 3, activityId: this.activityId, itemType: 2 }) //非持久化页面，不主动销毁此监听
    })
    try {
      this.showLoading()
      if (this.userPosition) {
        await this.handleRedRouteByCity()
      } else {
        await this.getUserPosition()
      }
    } catch (e) {
      window.console.error(e)
    }
    window.addEventListener('scroll', this.handleScroll, true)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    ...mapMutations({
      toast: 'toast/showToast',
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading',
    }),
    /**获取红色路线列表 */
    async handleRedRouteByCity(pageNum = 0) {
      if (this.isLoading || this.isLastPage) return
      this.isLoading=true
      const result = await getRedRouteByCity({
        pageNum: pageNum,
        pageSize: this.routeParams.pageSize,
        activityId: this.activityId,
        cityCode: this.selectedCity?.code !== '440000' ? this.selectedCity?.code : '',
        categoryIds: this.routeParams.categoryIds,
        searchText: this.routeParams.searchText,
      })
      this.isLastPage = result.last
      this.routeParams.pageNum = pageNum
      this.routeList = this.routeParams.pageNum == 0 ? result.content : this.routeList.concat(result.content)
      this.routeList.forEach((item) => {
        const point = item?.address?.point
        item.distance = this.getInfoDistance(point.x, point.y)
        item.titleName = item.name
        item.tagName = item?.redTemplate?.topCategory?.name
        item.openingHours = item?.redTemplate?.openingHours
      })
      this.isLoading = false
      this.showNoData = true
      this.hideLoading()
    },
    /**点击创建红色路线 */
    async handleCreateRoute() {
      if (!this.isHeightLinght) return
      if (this.selLineList.length < 2) {
        this.toast('请至少选择2个点')
        return
      }
      if (this.selLineList.length > 5) {
        this.toast('请至多选择5个点')
        return
      }
      const result = await createRedRoute({
        activityId: this.activityId,
        storeIds: this.selLineList,
      })
      if (result) {
        this.$router.push({ path: '/myRedRoute', query: { routeId: result, from: 'create', id: this.activityId } })
      }
    },
    /**获取用户距离遗址的距离 */
    getInfoDistance(pointX, pointY) {
      if (!this.userPosition) return
      return getDistance({ lng: pointX, lat: pointY }, { lng: this.userPosition?.longitude, lat: this.userPosition?.latitude })
    },
    /**获取用户的位置信息 */
    async getUserPosition() {
      /* global AMap */
      this.map = new AMap.Map('map-container-fake', {
        center: [113.325, 23.137],
      })
      this.map.plugin('AMap.Geolocation', () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          maximumAge: 0, // 定位结果缓存0毫秒，默认：0
          convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: false, // 显示定位按钮，默认：true
          showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true, // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        })
        this.map.addControl(geolocation)
        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, 'complete', this.onComplete) // 返回定位信息
        AMap.event.addListener(geolocation, 'error', this.onError) // 返回定位出错信息
      })
    },
    /**用户地理位置赋值 */
    onComplete(obj) {
      this.userPosition = {
        latitude: obj.position.lat,
        longitude: obj.position.lng,
        valid: true,
      }
      this.handleRedRouteByCity()
    },
    /**获取不到定位，默认用这个定位 */
    onError(obj) {
      window.console.log(180, obj)
      this.userPosition = this.defaultPosition
      this.handleRedRouteByCity()
    },
    /**取消搜索 */
    onCancel() {
      this.routeParams.searchText = ''
      this.isLastPage = false
      buryingPoint({ action: 8, sourceTag: 3, activityId: this.activityId, itemType: 2 })
      this.handleRedRouteByCity()
    },
    /**执行搜索 */
    onSearch() {
      this.routeList = []
      this.isLastPage = false
      this.handleRedRouteByCity()
    },
    /**滚动事件 */
    handleScroll() {
      const layout = document.getElementById('listBoxContent').getBoundingClientRect()
      if (-layout.top + body.height > layout.height - 250 && !this.isLastPage) {
        this.handleRedRouteByCity(this.routeParams.pageNum + 1)
      }
    },
    handleChangeCheckBox(e) {
      if (this.selLineList.length > 5) {
        this.toast('最多可选择5个红色遗址')
        this.selLineList = this.selLineList.slice(0, 5)
      }
    },
    handleCheckBoxClicked(e) {
      buryingPoint({ action: 18, sourceTag: 3, activityId: this.activityId, optionId:e, itemType: 2 })
    },
  },
}
</script>

<style lang="scss" scoped>
.create-route {
  padding: 0.2rem;
  box-sizing: border-box;
  height: 100vh;
  background-image: url('../../assets/images/banner.png');
  // background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  background-color: #f7f7f7;
  overflow: hidden;
  .banner-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3rem;
    background: url('../../assets/images/banner.png') no-repeat center center;
    background-size: cover;
    & > img {
      width: 100%;
    }
  }
  .search-box {
    background-color: #fff;
    box-shadow: 0 0.04rem 0.08rem 0 #716c6233;
    border-radius: 0.38rem;
    height: 0.76rem;
    line-height: 0.76rem;
    font-size: 0.28rem;
    color: #999;
    font-weight: 400;
    z-index: 99;
    margin-bottom: 0.2rem;
    .van-search {
      height: 100%;
      border-radius: 0.38rem;
      .van-search__content {
        background: transparent;
        .van-cell {
          border-right: 0.02rem solid #d8d8d8;
          align-items: center;
        }
      }
      .van-search__action {
        padding: 0 0.3rem;
        font-size: 0.28rem;
        color: #333;
        text-align: right;
      }
    }
  }

  .list-box {
    width: 100%;
    height: calc(100vh - 1.16rem);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    padding: 0.2rem 0.2rem 1.16rem;
    background: #fff;
    box-shadow: 0px -0.04rem 0.08rem 0px #716c6233;
    border-radius: 0.14rem 0.14rem 0px 0px;
  }
  .bottom-btn {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 1.16rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    z-index: 9999;
    & > div {
      width: calc(100% - 0.8rem);
      margin: 0 auto;
      height: 0.76rem;
      line-height: 0.76rem;
      text-align: center;
      opacity: 0.5;
      z-index: 9999;
      font-size: 0.3rem;
      font-weight: 400;
      border-radius: 0.38rem;
      color: #fff;
      background: linear-gradient(180deg, #ff601a 0%, #dc0808 100%);
    }
  }
  .bottom-btn.active > div {
    opacity: 1;
  }
}
</style>
<style lang="scss">
.create-route {
  .van-field__left-icon {
    margin-right: 0.2rem !important;
    width: 0.34rem;
    height: 0.34rem;
    & > img {
      width: 0.34rem;
      height: 0.34rem;
    }
  }
  .van-search__content {
    padding-left: 6px !important;
  }
  .van-field__control {
    font-size: 0.28rem;
    color: #333;
    font-weight: 400;
  }
  .van-field__body ::-webkit-input-placeholder {
    color: #999;
    font-size: 0.28rem;
    font-weight: 400;
  }
  .search-box .van-search .van-search__content .van-cell {
    border-right: 0 !important;
  }
  .van-search__action {
    position: relative;
  }
  .van-search__action::before {
    position: absolute;
    content: '';
    width: 0.02rem;
    height: 0.4rem;
    background: #d8d8d8;
    top: 50%;
    transform: translate(0, -50%);
    left: 0;
  }
}
</style>